<template>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="12" lg="12">
          <v-card class="rounded-xl elevation-4">
            <v-card-title class="primary white--text">
              <v-icon left color="white">mdi-monitor</v-icon>
              <span class="headline font-weight-bold">Cadastrar Painel</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="pa-6">
              <v-form ref="form" v-model="valid" @submit.prevent="submit">
                <v-text-field
                  v-model="nome"
                  label="Nome para identificação"
                  outlined
                  :rules="identificacaoRules"
                  prepend-icon="mdi-identifier"
                  required
                  class="mb-4"
                ></v-text-field>

                <v-text-field
                  v-model="username"
                  label="Login"
                  outlined
                  :rules="usernameRules"
                  prepend-icon="mdi-account"
                  required
                  class="mb-4"
                ></v-text-field>

                <v-text-field
                  v-model="senha"
                  :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
                  :type="showPassword ? 'text' : 'password'"
                  label="Senha"
                  outlined
                  :rules="senhaRules"
                  prepend-icon="mdi-lock"
                  counter
                  @click:append="showPassword = !showPassword"
                  class="mb-4"
                ></v-text-field>

                <v-autocomplete
                  v-model="idLocalEscolhido"
                  :items="listaLocais"
                  item-value="idLocal"
                  item-text="nomeLocal"
                  label="Local"
                  outlined
                  :rules="[v => !!v || 'Local é obrigatório']"
                  prepend-icon="mdi-map-marker"
                  required
                  class="mb-4"
                ></v-autocomplete>

                <v-radio-group
                  v-model="modoVisualizacao"
                  :rules="[v => !!v || 'Selecione uma opção']"
                  class="mb-4"
                >
                  <template v-slot:label>
                    <div class="font-weight-bold">Quais chamadas você deseja mostrar?</div>
                  </template>
                  <v-radio value="recepcao" label="Recepção"></v-radio>
                  <v-radio value="medico" label="Médico"></v-radio>
                  <v-radio value="recepcao-medico" label="Recepção e Médico"></v-radio>
                </v-radio-group>

                <v-checkbox
                  v-model="isTelevisao"
                  :true-value="1"
                  :false-value="0"
                  label="Exibir transmissão de canais no painel?"
                  class="mt-0 mb-4"
                ></v-checkbox>

                <v-checkbox
                  v-model="checkbox"
                  :rules="[v => !!v || 'Você deve concordar para continuar']"
                  label="Confirmo que as informações estão corretas"
                  required
                  class="mt-0"
                ></v-checkbox>

                <v-alert
                  v-model="erroLogin"
                  color="error"
                  icon="mdi-alert-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Username já está em uso!
                </v-alert>

                <v-alert
                  v-model="sucessoLogin"
                  color="success"
                  icon="mdi-check-circle"
                  dense
                  outlined
                  dismissible
                  class="mb-4"
                >
                  Painel cadastrado com sucesso!
                </v-alert>
              </v-form>
            </v-card-text>

            <v-card-actions class="pa-4">
              <v-spacer></v-spacer>
              <v-btn
                large
                outlined
                color="grey darken-1"
                :to="{ path: '/listaPaineisUnidade' }"
                class="mr-3"
              >
                <v-icon left>mdi-arrow-left</v-icon>
                Voltar
              </v-btn>
              <v-btn
                color="primary"
                large
                depressed
                :disabled="!valid || loading"
                :loading="loading"
                @click="submit"
                class="px-6"
              >
                <v-icon left>mdi-content-save</v-icon>
                Cadastrar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'CadastrarPainelUnidade',
  data () {
    return {
      showPassword: false,
      loading: false,
      valid: false,
      tipo: 6,
      isTelevisao: 0,
      modoVisualizacao: '',
      erroLogin: false,
      sucessoLogin: false,
      listaLocais: [],
      senha: '',
      username: '',
      nome: '',
      idLocalEscolhido: '',
      checkbox: true,
      senhaRules: [
        v => !!v || 'Senha é obrigatória',
        v => (v && v.length >= 6) || 'Senha deve ter pelo menos 6 caracteres'
      ],
      identificacaoRules: [
        v => !!v || 'Identificação é obrigatória'
      ],
      usernameRules: [
        v => !!v || 'Login é obrigatório',
        v => (v && v.length >= 8) || 'Login deve ter pelo menos 8 caracteres'
      ]
    }
  },
  async mounted () {
    await this.retornarLocais()
  },
  methods: {
    async retornarLocais () {
      try {
        const response = await administradorUnidadeService.administradorUnidade.retornarLocais()
        this.listaLocais = response.data || []
      } catch (error) {
        console.error('Erro ao buscar locais:', error)
        this.$notify({
          type: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar a lista de locais'
        })
      }
    },
    async submit () {
      if (!this.$refs.form.validate()) return

      this.loading = true
      this.erroLogin = false
      this.sucessoLogin = false

      try {
        const response = await administradorUnidadeService.administradorUnidade.cadastrarFuncionario(
          this.idLocalEscolhido,
          this.username,
          this.senha,
          this.tipo,
          this.nome,
          this.isTelevisao,
          this.modoVisualizacao
        )

        if (response.data === 'usernameExistente') {
          this.erroLogin = true
          return
        }

        if (response.data === true) {
          this.sucessoLogin = true
          this.$refs.form.reset()
        }
      } catch (error) {
        console.error('Erro ao cadastrar painel:', error)
        this.erroLogin = true
      } finally {
        this.loading = false
      }
    },
    clear () {
      this.$refs.form.reset()
    }
  }
}
</script>

<style scoped>
.rounded-xl {
  border-radius: 16px !important;
}

.v-card__title {
  border-top-left-radius: 16px !important;
  border-top-right-radius: 16px !important;
}

.v-btn {
  letter-spacing: normal;
  text-transform: none;
}

.v-btn--disabled {
  opacity: 0.6;
}
</style>
